import { useEffect, useState } from "react";
import { format } from "date-fns";
import axiosInstance from "../../api/axiosInstance";
import Select from "react-select";
import Loader from "../../common/Loader";

const SiteReport = () => {
  const today = format(new Date(), "yyyy-MM-dd");
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-12-31");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [salePersonData, setSalePersonData] = useState([]);
  const [selectedSalePerson, setSelectedSalePerson] = useState(null);

  const fetchSalePersons = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("User/GetAllUser");
      setSalePersonData(response.data);
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchReport = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("Report/GetFilteredNewDeals", {
        fromDate,
        toDate,
        sale_Person_Id: selectedSalePerson
          ? parseInt(selectedSalePerson.value)
          : null,
      });
      setReportData(response.data);
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
    fetchSalePersons();
  }, []);

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: "200px",
      fontSize: "14px",
    }),
  };
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Sites Report</h2>
      {/* Filters */}
      <div className="flex flex-wrap gap-4 mb-4">
        <div>
          <label className="text-sm text-gray-600 font-medium">From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full px-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <div>
          <label className="text-sm text-gray-600 font-medium">To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="w-full px-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div>
          <label className="text-sm text-gray-600 font-medium">
            Sale Person
          </label>
          <Select
            options={salePersonData.map((per) => ({
              value: String(per.sale_Person_Id),
              label: per.Sale_Person_Name,
            }))}
            value={selectedSalePerson}
            onChange={setSelectedSalePerson}
            isClearable
            styles={selectStyles}
          />
        </div>
        <div className="self-end">
          <button
            onClick={fetchReport}
            className="bg-secondary text-white px-5 py-2 rounded-md hover:bg-secondary-dark transition"
          >
            Search
          </button>
        </div>
      </div>

      {/* Report Table */}
      {loading ? (
        <Loader />
      ) : (
        <div className="overflow-x-auto border rounded">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-primary text-white">
              <tr>
                <th className="px-4 py-2 text-left">Site Name</th>
                <th className="px-4 py-2 text-left">Site Type</th>
                <th className="px-4 py-2 text-left">Contact person</th>
                <th className="px-4 py-2 text-left">Site Address</th>
                <th className="px-4 py-2 text-left">Owner Name</th>
                <th className="px-4 py-2 text-left">Site Location</th>
                <th className="px-4 py-2 text-left">Architect Name</th>
                <th className="px-4 py-2 text-left">Sale Person</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {reportData.length > 0 ? (
                reportData.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-2 ">{item.site_Name}</td>
                    <td className="px-4 py-2 ">{item.site_Type}</td>
                    <td className="px-4 py-2 ">{item.contact_Person}</td>

                    <td className="px-4 py-2 ">{item.site_Address}</td>
                    <td className="px-4 py-2 ">{item.owner_Name}</td>
                    <td className="px-4 py-2 ">{item.site_Location_Link}</td>
                    <td className="px-4 py-2 ">{item.architect_Name}</td>
                    <td className="px-4 py-2 ">{item.salesPerson_Name}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center text-gray-500 py-4 font-medium"
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SiteReport;
